import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../state/store';
import { selectAuth } from '../state/auth';
import { CompanyFeature, companyHasFeature } from '../config/companyFeatures';

interface Props {
  feature: CompanyFeature;
}

// Route guard for Feature Access: blocks a screen unless Artyc has granted the
// active company access to it. Pairs with the sidebar gating so a hidden screen
// can't be reached by URL either.
const RequireCompanyFeature = ({ feature }: Props) => {
  const auth = useSelector(selectAuth);
  const companies = useSelector((state: RootState) => state.companies.data);
  const currentCompany = companies.find((c) => c._id === auth?.companyId);

  // Companies haven't loaded yet — don't bounce the user on a cold deep-link;
  // the nav/route re-evaluate once the company is in state.
  if (companies.length === 0) {
    return <Outlet />;
  }

  return companyHasFeature(currentCompany?.featureAccess, feature) ? (
    <Outlet />
  ) : (
    <Navigate to="/portal/home" replace />
  );
};

export default RequireCompanyFeature;
